import CloseIcon from '@mui/icons-material/Close';
import LayersIcon from '@mui/icons-material/Layers';
import { Paper, Tooltip } from '@mui/material';
import TextField from "@mui/material/TextField/TextField";
import * as React from "react";
import { getHeightRestrictions } from "../../../services/OgcService/HeightRestrictionService";
import { useCurrentHeight, useHeightRestrictionActions, useHeightRestrictionIsLoading, useHeightRestrictions } from "../../../stores/MapLayers/HeightRestrictionStore";
import { useRouteDrawerOpen } from "../../../stores/RouteStore";
import { HeightRestrictionsMapLayer } from "./HeightRestrictionsMapLayer";
import { TrafficMessageMapLayer } from "./TrafficMessageMapLayer";
import { RoadFeaturesMapLayer } from './RoadFeaturesMapLayer';
import { ObstructingFeaturesMapLayer } from './ObstructingFeaturesMapLayer';
import { RoadFeatureResponseMapLayer} from './RoadFeatureResponseMapLayer';
import { RouteOnMapLayer } from './RouteOnMapLayer';

function GetClassName(routeFeatureDialogIsOpen: boolean, checked: boolean) {

    if (checked) {
        if (routeFeatureDialogIsOpen) {
            return "mapLayerContainer mapLayerSelectorMarginLeft"
        }
        return "mapLayerContainer"
    }

    if (routeFeatureDialogIsOpen) {
        return "mapLayerSelector mapLayerSelectorMarginLeft"
    }
    return "mapLayerSelector";
}

export function MapLayerSelector() {
    const [checked, setChecked] = React.useState(false);
    const heightRestrictions = useHeightRestrictions();
    const isLoading = useHeightRestrictionIsLoading();
    const currentHeight = useCurrentHeight();
    const {setHeightRestrictions, setIsLoading, setCurrentHeight} = useHeightRestrictionActions();
    
    const [newHeight, setNewHeight] = React.useState(currentHeight);
    const routeDrawerOpen = useRouteDrawerOpen();

    const handleChange = () => {
        setChecked((prev) => !prev);
    };

    if (!checked) {
        return (
            <Tooltip title="Vis kartlag" placement="bottom">
                <Paper
                    className={GetClassName(routeDrawerOpen, checked)}
                    onClick={handleChange}>

                    <LayersIcon style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', width: '100%', height: '100%' }}></LayersIcon>

                </Paper>
            </Tooltip>
        )
    }
    else {
        return (
            <div
                className={GetClassName(routeDrawerOpen, checked)}>
                <Paper style={{
                    minWidth: '15vw',
                    cursor: 'default',
                    display: 'flex',
                    borderRadius: '5px',
                    animationName: 'widen',
                    animationDuration: '.3s'
                }} >

                    <RoadFeaturesMapLayer />
                    <RouteOnMapLayer />
                    <TrafficMessageMapLayer />
                    <HeightRestrictionsMapLayer />
                    <ObstructingFeaturesMapLayer/>
                    <RoadFeatureResponseMapLayer/>

                    {(isLoading || heightRestrictions != null) &&
                        <div style={{ backgroundColor: 'white', width: '6vw', display: 'flex', marginLeft: '20px' }}>
                            <TextField
                                style={{ margin: 'auto', width: '6vw' }}
                                label="Skilta høyde"
                                type='number'
                                size="small"
                                inputProps={{ step: '0.5', inputMode: 'numeric', pattern: '[0-9]*' }}
                                value={newHeight}
                                onKeyDown={async (event: React.KeyboardEvent<HTMLDivElement>) => {
                                    if (event.key === 'Enter') {
                                        setCurrentHeight(newHeight)
                                        setIsLoading(true);
                                        setHeightRestrictions(await getHeightRestrictions(newHeight))
                                        setIsLoading(false);
                                    }
                                }}
                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    setNewHeight(event.target.value as unknown as number);
                                }} />
                        </div>
                    }
                    <div style={{ cursor: 'pointer', zIndex: '9999999' }} onClick={handleChange}>
                        <CloseIcon fontSize="medium"></CloseIcon>
                    </div>
                </Paper>
            </div>
        )
    }

}